module.exports = __webpack_public_path__ + "media/src/images/icon/user-blue-d79dcf62a5cbd89eb652013925f209e5.png";